








































import { Component, Vue, Watch } from 'vue-property-decorator'
import EventBus from '@/plugins/EventBus'
import { maskMoney, maskCPFCNPJ } from '@/utils/common'

@Component

export default class ComponentRecebimentoItemInstrucoes extends Vue {
  showDialogInstruirEmissaoDeNota: boolean = false
  instrucoesDefault: any = {
    valorBruto: 0,
    prestador: '',
    cnpjPrestador: '',
    fontePagadora: '',
    cnpjFontePagadora: '',
  }

  instrucoes: any = { ...this.instrucoesDefault }

  maskMoneyUtil(value) {
    return maskMoney(value)
  }

  maskCPFCNPJUtil(value) {
    return maskCPFCNPJ(value)
  }

  @Watch('showDialogInstruirEmissaoDeNota')
  onChangeShowDialogInstruirEmissaoDeNota(value: boolean) {
    if (!value) {
      this.instrucoes = { ...this.instrucoesDefault }
    }
  }

  mounted() {
    EventBus.$on('instruirEmissaoDeNota', (data: any) => {
      this.showDialogInstruirEmissaoDeNota = data.open
      this.instrucoes = { ...data.instrucoes }
    })
  }
}

